import { useCallback, useEffect, useState } from 'react';

const KEY = 'lux.ledgerView';
const EVT = 'lux:ledger-view';
const read = () => (window.localStorage.getItem(KEY) === 'line' ? 'line' : 'invoice');

/**
 * 'invoice' (one row per supplier invoice, default) or 'line' (one row per
 * ledger line). One shared per-browser preference across every place the
 * Cost Ledger appears — mirrors the Ex/Inc-VAT toggle.
 */
export function useLedgerView() {
  const [view, setViewState] = useState(read);
  useEffect(() => {
    const sync = () => setViewState(read());
    window.addEventListener(EVT, sync);
    window.addEventListener('storage', sync);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener('storage', sync); };
  }, []);
  const setView = useCallback((v) => {
    window.localStorage.setItem(KEY, v === 'line' ? 'line' : 'invoice');
    window.dispatchEvent(new Event(EVT));
  }, []);
  return [view, setView];
}

export const VIEW_LABEL = { invoice: 'Invoice', line: 'Line' };

const OPTIONS = [['invoice', 'Invoice'], ['line', 'Line']];

/** Segmented Invoice / Line switch, styled to sit with the ledger filter controls. */
export function LedgerViewToggle({ view, onChange, className = '', testid = 'ledger-view-toggle' }) {
  return (
    <div role="group" aria-label="Ledger grouping" title="Group the ledger by supplier invoice, or show one row per line"
      className={`inline-flex items-center rounded-full border p-0.5 bg-white/5 border-white/10 ${className}`} data-testid={testid}>
      {OPTIONS.map(([key, label]) => (
        <button key={key} type="button" onClick={() => onChange(key)} aria-pressed={view === key}
          className={`rounded-full font-semibold uppercase tracking-wider transition-colors duration-150 px-2.5 py-1 text-[11px] ${view === key ? 'bg-[#F5A623] text-[#1E2530] shadow-sm' : 'text-gray-400 hover:text-white'}`}
          data-testid={`${testid}-${key}`}>
          {label}
        </button>
      ))}
    </div>
  );
}
